import React from 'react';
import PropTypes from 'prop-types';

function QRIcon({ zoom }) {
  return (
    <span style={{ zoom }}>
      <svg
        width="42.48px"
        height="42.48px"
        viewBox="0 0 36 36"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-925.000000, -423.000000)" fillRule="nonzero">
            <g transform="translate(818.000000, 186.000000)">
              <g transform="translate(107.000000, 237.000000)">
                <g transform="translate(-0.000000, 0.000000)">
                  <path d="M-3.64153152e-13,25.5 L3,25.5 L3,33 L10.5,33 L10.5,36 C6.48453159,36 3.98284085,36 2.99492778,36 C1.51305819,36 5.31898413e-13,35.0000759 8.22210484e-14,33.5466707 C-2.17419664e-13,32.5777338 -3.66211064e-13,29.8955103 -3.64153152e-13,25.5 Z" id="Rectangle" fill="#225971" />
                  <path d="M25.5,25.5 L28.5,25.5 L28.5,33 L36,33 L36,36 C31.9845316,36 29.4828409,36 28.4949278,36 C27.0130582,36 25.5,35.0000759 25.5,33.5466707 C25.5,32.5777338 25.5,29.8955103 25.5,25.5 Z" id="Rectangle" fill="#225971" transform="translate(30.750000, 30.750000) scale(-1, 1) translate(-30.750000, -30.750000) " />
                  <path d="M1.45483625e-12,2.77111667e-13 L3,2.77111667e-13 L3,7.5 L10.5,7.5 L10.5,10.5 C6.48453159,10.5 3.98284085,10.5 2.99492778,10.5 C1.51305819,10.5 2.35088782e-12,9.5000759 1.90121045e-12,8.04667066 C1.60156974e-12,7.07773384 1.45277834e-12,4.39551028 1.45483625e-12,2.77111667e-13 Z" id="Rectangle" fill="#225971" transform="translate(5.250000, 5.250000) rotate(-270.000000) translate(-5.250000, -5.250000) " />
                  <path d="M25.5,2.77111667e-13 L28.5,2.77111667e-13 L28.5,7.5 L36,7.5 L36,10.5 C31.9845316,10.5 29.4828409,10.5 28.4949278,10.5 C27.0130582,10.5 25.5,9.5000759 25.5,8.04667066 C25.5,7.07773384 25.5,4.39551028 25.5,2.77111667e-13 Z" id="Rectangle" fill="#225971" transform="translate(30.750000, 5.250000) scale(-1, 1) rotate(-270.000000) translate(-30.750000, -5.250000) " />
                  <polygon fill="#225971" points="16.5 16.5 22.5 16.5 22.5 19.497346 19.5 19.497346 19.5 22.5 16.5 22.5" />
                  <rect fill="#225971" x="24" y="16.5" width="3" height="3" />
                  <polygon id="Path" fill="#225971" points="30 30 21 30 21 24 24 24 24 27 27 27 27 22.5 30 22.5" />
                  <rect fill="#225971" x="16.5" y="12" width="3" height="3" />
                  <rect fill="#225971" x="16.5" y="6" width="3" height="3" />
                  <rect fill="#225971" x="16.5" y="25" width="3" height="3" />
                  <rect stroke="#215970" strokeWidth="3" x="7.5" y="7.5" width="6" height="6" />
                  <rect stroke="#215970" strokeWidth="3" x="7.5" y="22.5" width="6" height="6" />
                  <rect stroke="#215970" strokeWidth="3" x="22.5" y="7.5" width="6" height="6" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

QRIcon.defaultProps = {
  zoom: '1',
};

QRIcon.propTypes = {
  zoom: PropTypes.string,
};

export default QRIcon;
